import { render, staticRenderFns } from "./editBnr.vue?vue&type=template&id=5d46e974&scoped=true"
import script from "./editBnr.vue?vue&type=script&lang=js"
export * from "./editBnr.vue?vue&type=script&lang=js"
import style0 from "./editBnr.vue?vue&type=style&index=0&id=5d46e974&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d46e974",
  null
  
)

export default component.exports